import type { ReactNode } from "react";

export type ButtonProps = {
  icon?: ReactNode;
  action?: () => void;
  children: ReactNode;
  bgColor: "secondary-light" | "primary-text" | "green-light" | "white";
  textColor: "primary-text" | "white" | "secondary-light";
  borderColor?: "primary-text";
  disabled?: boolean;
  to?: {
    href: string;
    target?: React.AnchorHTMLAttributes<HTMLAnchorElement>["target"];
  };
  className?: string;
};

export const Button = ({
  icon,
  action,
  bgColor,
  textColor,
  borderColor,
  disabled,
  children,
  to,
  className,
}: ButtonProps) => {
  const borderClass =
    borderColor === "primary-text" ? "border border-primary-text/40" : "";

  const bgClass = bgColor ? `bg-${bgColor}` : "";
  const textClass = textColor ? `text-${textColor}` : "";

  const Bttn = (
    <button
      type="button"
      disabled={disabled}
      className={`flex w-full h-full items-center gap-1 rounded-full px-5 py-3 shadow-[0_12px_30px_rgba(119,111,84,0.12)] ${bgClass} ${textClass} ${borderClass} hover:cursor-pointer hover:-translate-y-0.5 hover:bg-green-light disabled:cursor-not-allowed disabled:opacity-60 ${className || ""}`}
      onClick={() => {
        action?.();
      }}
    >
      {icon}
      <div className="flex-1 text-sm font-semibold tracking-[0.14em] uppercase">
        {children}
      </div>
    </button>
  );

  if (to) {
    return (
      <a
        href={to.href}
        target={to.target}
        rel={to.target === "_blank" ? "noopener" : undefined}
        className="block flex-1"
      >
        {Bttn}
      </a>
    );
  }

  return Bttn;
};
